import { FileUpload } from "primereact/fileupload";
import React, { useContext, useRef } from "react";
import Labels from "../../infrastructure/Labels_sr_Latn_RS";
import { Button } from "primereact/button";
import { saveAs } from "file-saver";
import axios from "axios";
import { axiosConfig } from "../../utils/Utils";
import { AppContext } from "../Store";
import Endpoint from "../../endpoints/Endpoint";
import MessageType from "../../infrastructure/MessageType";
export default function Datoteka({ initValue, changeState, auts, tipSkupaAtributaKey }) {
  const { authData } = useContext(AppContext);
  const { showGrowlMessage } = useContext(AppContext);

  const handleChange = (value) => {
    let stateArray = [
      ["initValue", tipSkupaAtributaKey, value],
      ["prikazAUTS", auts.sifra, value],
    ];
    changeState(stateArray);
  };
  const datotekaUploadRef = useRef(null);
  const datotekaUploadHandler = (e) => {
    e.files.forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        if (reader.result) {
          handleChange({
            fileContent: reader.result.toString().substr(reader.result?.toString().indexOf(",") + 1),
            fileName: file.name,
            fileSize: file.size,
            fileType: file.type,
          });
        }
      };
    });

    datotekaUploadRef.current.clear();
  };
  const downloadDatoteka = () => {
    if (initValue && initValue.fileContent) {
      let FILE_TYPE = initValue.fileType;
      const byteChars = atob(initValue.fileContent);
      const dataArray = new Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) {
        dataArray[i] = byteChars.charCodeAt(i);
      }
      const byteArray = new Uint8Array(dataArray);
      const data = new Blob([byteArray], {
        type: FILE_TYPE,
      });
      saveAs(data, initValue.fileName);
    } else if (initValue.keyVrednostAtributaDatoteka) {
      axios.get(Endpoint.VREDNOST_ATRIBUTA_DATOTEKA + "/" + initValue.keyVrednostAtributaDatoteka, axiosConfig(authData.token)).then((response) => {
        let FILE_TYPE = response.data.fileType;
        const byteChars = atob(response.data.fileContent);
        const dataArray = new Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) {
          dataArray[i] = byteChars.charCodeAt(i);
        }
        const byteArray = new Uint8Array(dataArray);
        const data = new Blob([byteArray], {
          type: FILE_TYPE,
        });
        saveAs(data, initValue.fileName);
      });
    }
  };
  return (
    <div className="d-inline ">
      {initValue && initValue.fileName ? (
        <div>
          <button style={{ background: "none", border: "none", color: "blue" }} onClick={() => downloadDatoteka()}>
            {initValue.fileName}
            {"  "}
          </button>

          <Button
            tooltip={Labels.REMOVE_DOKUMENT}
            className="p-button-outlined p-button-danger"
            icon="pi pi-trash"
            onClick={() => {
              handleChange({ fileContent: "" });
            }}
          />
        </div>
      ) : (
        <FileUpload
          ref={datotekaUploadRef}
          customUpload
          auto
          uploadHandler={datotekaUploadHandler}
          mode="basic"
          chooseLabel={Labels.LABEL_DODAJ}
          accept=".*"
          maxFileSize={15728640}
          onValidationFail={(file) => {
            if (file.size > 15728640) {
              showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA_PREVELIKA_DATOTEKA);
            }
          }}
        />
      )}
    </div>
  );
}
